import uniqid from 'uniqid'
import GitHubIcon from '@material-ui/icons/GitHub'
import LaunchIcon from '@material-ui/icons/Launch'
import './ProjectContainer.css'

const ProjectContainer = ({ project }) => (
  <div className='project'>
    <h3>{project.name}</h3>

    <p className='project__description'>
      <p style={{fontWeight: 'bold'}}>
      {project.description}
      </p>
      <ul>
        {
          project.task.map((item) => (
            <div className="project__detail">
              <span>&gt;</span>
              <li>{item}</li>
            </div>
          ))
        }
      </ul>
    </p>
    {project.stack && (
      <ul className='project__stack'>
        {project.stack.map((item) => (
          <li key={uniqid()} className='project__stack-item'>
            {item}
          </li>
        ))}
      </ul>
    )}

    {project.sourceCode && (
      <div style={{display: 'flex', justifyContent: 'center'}}>
        <a
          href={project.sourceCode}
          aria-label='source code'
          className='link link--icon'
        >
          <GitHubIcon />
        </a>
      </div>
    )}
  </div>
)

export default ProjectContainer
